import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPeopleIdCard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPeopleIdCard"><Path fillRule="evenodd" clipRule="evenodd" d="M20.5 22H3.5V2H20.5V22ZM12 16C10 16 7.48535 17.522 7.48535 20.0156H16.5156C16.5156 17.522 14 16 12 16ZM12 9.5C10.6193 9.5 9.5 10.6193 9.5 12C9.5 13.3807 10.6193 14.5 12 14.5C13.3807 14.5 14.5 13.3807 14.5 12C14.5 10.6193 13.3807 9.5 12 9.5ZM9 6H15V4H9V6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPeopleIdCard;
